// Packages
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
// Parts
import Carousel from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/carousel';
// Services
import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';
import FacilityUnitService from '@PROJECT_ROOT/assets/responsive-frontend/js/apiServices/FacilityUnitService';
import windowManipulationService from '@PROJECT_ROOT/assets/responsive-frontend/js/services/windowManipulationService';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import {
    dispatchTrackingEvent,
    RESERVATION_FORM_UNIT_CARD_ADD_UNIT,
    RESERVATION_FORM_UNIT_CARD_PERSONS_EDIT,
    RESERVATION_FORM_UNIT_CARD_REMOVE_MAIN_UNIT,
    RESERVATION_FORM_UNIT_CARD_REMOVE_UNIT,
    RESERVATION_FORM_UNIT_CARD_UNIT_DETAILS,
    UNIT_PRESENTATION_UNIT_CARD_TITLE_LINK_TO_PRESENTATION_CLICK,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';
// Utils
import {
    sumAllUnitGuests,
    sumAllUnitChildren,
} from '@PROJECT_ROOT/assets/responsive-frontend/js/services/utils';
// Icons
import { MdOutlineRemoveRedEye, MdOutlineCreate, MdOutlineArrowOutward } from 'react-icons/md';

function renderFacilityUnitCardImageSourceElements(item) {
    return (
        <>
            {item.imageSourceURLMediumSizeAlternative && (
                <source
                    srcSet={item.imageSourceURLMediumSizeAlternative}
                    media="(max-width: 767.98px)"
                />
            )}
            {item.imageSourceURLLargeSizeAlternative && (
                <source
                    srcSet={item.imageSourceURLLargeSizeAlternative}
                    media="(min-width: 4000px)"
                />
            )}
        </>
    );
}

function FacilityUnitCard({
    data,
    sharedData,
    priceData,
    selectHandler,
    currentReservationParameters,
    modalHandler,
    guestSelectHandler,
    isLoading,
    fetchForID,
    isMobileClient,
}) {
    const isClientSideRendering = windowManipulationService.isBrowserEnvironment();
    // TODO: #58308 Privremeno, nakon comitt-a prve verzije će se uklonit ili doradit.
    // Pribacit u servis ili poslat reportService-u flag da baci toast poruku.
    const axiosCustomErrors = isClientSideRendering && JSON.parse(document.getElementById('mainWrapper')?.getAttribute('data-axios'));
    const { unitId } = data;
    const [isUnitSelected, setIsUnitSelected] = useState(false);
    const [unitMainGallery, setUnitMainGallery] = useState([data?.mainImages[0]]);
    const [galleryIndexToJumpTo, setGalleryIndexToJumpTo] = useState(null);
    const [galleryLoaded, setGalleryLoaded] = useState(false);
    const [isLoadingUnitMainGallery, setIsLoadingUnitMainGallery] = useState(false);
    const [isUnavailableForBooking, setIsUnavailableForBooking] = useState(false);
    const [isSelectDisabled, setIsSelectDisabled] = useState(false);

    useEffect(() => {
        // setIsUnitSelected(data.isMainUnit ? data.isMainUnit || priceData.selected : currentReservationParameters.selectedUnits.some((unitItem) => unitItem.unitId === unitId));
        setIsUnitSelected(priceData.selected || currentReservationParameters.selectedUnits.some((unitItem) => unitItem.unitId === unitId));
        setIsUnavailableForBooking(priceData.availableForBooking === false);
        setIsSelectDisabled(priceData.availableForBooking === false);
    }, [data, priceData, unitId, currentReservationParameters]);

    const getUnitMainGallery = (moveDirection) => {
        if (galleryLoaded || isLoadingUnitMainGallery) return;
        setIsLoadingUnitMainGallery(true);
        FacilityUnitService
            .getPresentationUnitGalleryData(unitId)
            .then((res) => {
                if (res?.status === 200 && res?.data) {
                    // TODO: #58308 Privremeno, nakon comitt-a prve verzije će se uklonit ili doradit.
                    // Flatt-am postojeću strukturu data.items-a jer postojeći carousel očekuje takvu strukturu (nisam želio raditi još jednu komponentu za slider, imamo već 3).
                    // Potrebno je standarizirat jedan carousel ili swiper koji će biti fleksibilan i neovisan o key-evima za slike.
                    const flattenedImages = {
                        items: res.data.items?.flatMap((item) => item.images?.map((img) => ({
                            ...img,
                            image: img.image,
                        }))),
                    };
                    setGalleryLoaded(true);
                    setUnitMainGallery(flattenedImages.items);
                    let moveToImageIndex = 0;
                    if (moveDirection) {
                        moveToImageIndex = moveDirection === 'next' ? 1 : flattenedImages.items.length - 1;
                    }
                    setGalleryIndexToJumpTo(moveToImageIndex);
                    return;
                }
                reportError(res);
            })
            .catch((err) => {
                toast.error(axiosCustomErrors?.unavailableText);
                reportError(err);
            })
            .finally(() => {
                setIsLoadingUnitMainGallery(false);
            });
    };

    return (
        <div
            className={`facility-unit-card d-flex justify-content-between ${isUnavailableForBooking ? 'facility-unit-card--unavailable' : ''} ${isUnitSelected ? ' facility-unit-card--selected' : ''} ${isLoading && (String(data.unitId) === String(fetchForID)) ? ' disableCurrentElementContent--spinner' : ''}`}
            id={data.unitId}
        >
            {sharedData.selectedUnitText && (
                <span className={`facility-unit-card__selected-badge ${isUnitSelected ? 'facility-unit-card__selected-badge--visible' : ''}`}>
                    {sharedData.selectedUnitText}
                </span>
            )}
            {priceData.unitNotAvailableText && (
                <span className={`facility-unit-card__unavailable-badge ${isUnavailableForBooking ? 'facility-unit-card__unavailable-badge--visible' : ''}`}>
                    {priceData.unitNotAvailableText}
                </span>
            )}
            <div className="facility-unit-card__slider">
                {unitMainGallery.length > 0 && (
                    <Carousel
                        data={{
                            items: unitMainGallery,
                            id: data.unitId,
                        }}
                        isGalleryLoaded={galleryLoaded}
                        autoplay={false}
                        imageWidth={240}
                        imageHeight={160}
                        imageSourceElements={renderFacilityUnitCardImageSourceElements}
                        customObjectFit="cover"
                        firstImageLazy={true}
                        galleryFetching={isLoadingUnitMainGallery}
                        onCurrentIndexChanged={() => {}} // Ovakav način samo da bi zadovoljili komponetu.
                        fetchGallery={getUnitMainGallery}
                        indexToJumpTo={galleryIndexToJumpTo}
                        trackingEvents={{
                            facilityUnitCard: {
                                onNext: 'unitPresentationUnitCardGalleryNext',
                            },
                        }}
                    />
                )}
            </div>
            <div className="facility-unit-card__content d-flex flex-column justify-content-between">
                <div className="facility-unit-card__content-header d-flex flex-column">
                    <h2 className="facility-unit-card__content-header-title">
                        {priceData.unitPresentationURL ? (
                            <a
                                href={priceData.unitPresentationURL}
                                className="facility-unit-card__content-header-title__link d-flex justify-content-between"
                                style={{ textDecoration: 'none', color: 'inherit' }}
                                target={`${isMobileClient ? '_self' : '_blank'}`}
                                rel={isMobileClient ? 'noreferrer' : 'noopener noreferrer'}
                                role="button"
                                onClick={() => {
                                    if (!IS_FRAME_SERVICE) dispatchTrackingEvent(UNIT_PRESENTATION_UNIT_CARD_TITLE_LINK_TO_PRESENTATION_CLICK);
                                }}
                            >
                                <span>{data.unitTitle}</span>
                                <span className="facility-unit-card__content-header-title-icon-wrap d-flex justify-content-center align-content-center">
                                    <MdOutlineArrowOutward className="facility-unit-card__content-header-title-icon" />
                                </span>
                            </a>
                        ) : (
                            data.unitTitle
                        )}
                    </h2>
                    <div className="facility-unit-card__content-header-info-wrap d-flex flex-column">
                        {data.areaAndPositionBasicInformation && (
                            <div className="facility-unit-card__content-header-basic-info d-flex flex-wrap">
                                {data.areaAndPositionBasicInformation.length > 0
                                && data.areaAndPositionBasicInformation.map((itemAreaAndPositionBasicInformation, indexAreaAndPositionBasicInformation) => (
                                    <div
                                        key={indexAreaAndPositionBasicInformation}
                                        className="facility-unit-card__content-header-basic-info-item d-flex align-items-center"
                                    >
                                        {itemAreaAndPositionBasicInformation.icon && (
                                            <>
                                                <span
                                                    className={`facility-unit-card__content-header-basic-info-item__icon ${itemAreaAndPositionBasicInformation.icon.sourceURL}`}
                                                    aria-hidden="true"
                                                />
                                                <span className="sr-only">{itemAreaAndPositionBasicInformation.icon.altText}</span>
                                            </>
                                        )}
                                        <span
                                            className="facility-unit-card__content-header-basic-info-item-txt"
                                            dangerouslySetInnerHTML={{ __html: itemAreaAndPositionBasicInformation.informationHTMLContent }}
                                        />
                                    </div>
                                )) }
                            </div>
                        )}
                        {data.roomToiletAndCapacityCountBasicInformation && (
                            <div className="facility-unit-card__content-header-basic-info d-flex flex-wrap">
                                {data.roomToiletAndCapacityCountBasicInformation.length > 0
                                && data.roomToiletAndCapacityCountBasicInformation.map((itemRoomToiletAndCapacityCountBasicInformation, indexRoomToiletAndCapacityCountBasicInformation) => (
                                    <div
                                        key={indexRoomToiletAndCapacityCountBasicInformation}
                                        className="facility-unit-card__content-header-basic-info-item d-flex align-items-center"
                                    >
                                        {itemRoomToiletAndCapacityCountBasicInformation.icon && (
                                            <>
                                                <span
                                                    className={`facility-unit-card__content-header-basic-info-item__icon ${itemRoomToiletAndCapacityCountBasicInformation.icon.sourceURL}`}
                                                    aria-hidden="true"
                                                />
                                                <span className="sr-only">{itemRoomToiletAndCapacityCountBasicInformation.icon.altText}</span>
                                            </>
                                        )}
                                        <span
                                            className="facility-unit-card__content-header-basic-info-item-txt"
                                            dangerouslySetInnerHTML={{ __html: itemRoomToiletAndCapacityCountBasicInformation.informationHTMLContent }}
                                        />
                                    </div>
                                )) }
                            </div>
                        )}
                    </div>
                </div>
                {!data.isMainUnit && sharedData.moreDetailsText && (
                    <button
                        type="button"
                        className="facility-unit-card__content-more d-flex align-items-center toggler__content--visible"
                        onClick={() => {
                            modalHandler(data.unitId);
                            if (!IS_FRAME_SERVICE) dispatchTrackingEvent(RESERVATION_FORM_UNIT_CARD_UNIT_DETAILS);
                        }}
                    >
                        <MdOutlineRemoveRedEye className="facility-unit-card__content-more-icon" />
                        <span className="facility-unit-card__content-more-txt">{sharedData.moreDetailsText}</span>
                    </button>
                )}
                {data.basicAmenities && (
                    <ul className="facility-unit-card__content-footer d-flex flex-wrap">
                        {data.basicAmenities.length > 0 && data.basicAmenities.map((itemBasicAmenities, indexBasicAmenities) => (
                            <li
                                key={indexBasicAmenities}
                                className="facility-unit-card__content-footer-item d-flex align-items-center"
                            >
                                {itemBasicAmenities.icon && (
                                    <>
                                        <span
                                            className={itemBasicAmenities.icon.sourceURL}
                                            aria-hidden="true"
                                        />
                                        <span className="sr-only">{itemBasicAmenities.icon.altText}</span>
                                    </>
                                )}
                                <span
                                    className="facility-unit-card__content-footer-item-txt"
                                >
                                    {itemBasicAmenities.title}
                                </span>
                            </li>
                        )) }
                    </ul>
                )}
            </div>
            <div
                className={`facility-unit-card__info d-flex flex-column justify-content-between ${isUnavailableForBooking ? 'facility-unit-card__info--disabled' : ''}`}
            >
                {isUnavailableForBooking && (
                    <hr className="facility-unit-card__info-mob-line d-block d-md-none" />
                )}
                <div className={`facility-unit-card__info-price-responsive-wrap ${isUnavailableForBooking ? 'facility-unit-card__info-price--hide-mob' : ''}`}>
                    <div className="facility-unit-card__info-price d-flex flex-column">
                        <p className="facility-unit-card__info-price-old">{priceData?.priceWithoutDiscount}</p>
                        <p className="facility-unit-card__info-price-actual">{priceData?.price}</p>
                        {/* TODO: Ova logika ce mozda ici za rasprodane jer onda u actual prikazivam orginalPrice, prodiskutriat sa Tihanom */}
                        {/* {(priceData?.originalPrice && priceData?.discountedPrice) ? (
                            <>
                                <p className="facility-unit-card__info-price-old">{priceData?.originalPrice}</p>
                                <p className="facility-unit-card__info-price-actual">{priceData?.discountedPrice}</p>
                            </>
                        ) : (
                            <p className="facility-unit-card__info-price-actual">{priceData?.originalPrice}</p>
                        )} */}
                    </div>
                    <div
                        className={`facility-unit-card__info-picker d-flex justify-content-between align-items-center ${isUnitSelected ? 'toggler__content--visible' : 'toggler__content--hidden'} `}
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                            guestSelectHandler(priceData);
                            if (!IS_FRAME_SERVICE) dispatchTrackingEvent(RESERVATION_FORM_UNIT_CARD_PERSONS_EDIT);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') guestSelectHandler(priceData);
                        }}
                    >
                        <div className="facility-unit-card__info-picker__txt d-flex flex-column">
                            <p className="facility-unit-card__info-picker-txt-guests-sum">
                                <span>{sharedData.simpleReservationFormLabels.guestsTitle}:&nbsp;{sumAllUnitGuests(priceData)}</span>
                            </p>
                            <p className="facility-unit-card__info-picker-txt-guests-info">
                                <span>{sharedData.simpleReservationFormLabels.adultsTitle}:&nbsp;{priceData.adultsCount}</span>
                                {sumAllUnitChildren(priceData) > 0 && (
                                    <span>&#44;&nbsp;{sharedData.simpleReservationFormLabels.childrenTitle}:&nbsp;{sumAllUnitChildren(priceData)}</span>
                                )}
                            </p>
                        </div>
                        <div className="facility-unit-card__info-picker-icon-wrap d-flex justify-content-center align-items-center">
                            <MdOutlineCreate className="facility-unit-card__info-picker-icon" />
                        </div>
                    </div>
                </div>
                <div className="facility-unit-card__info-toggler">
                    <label className="facility-unit-card__info-toggler-switch-wrapper d-flex justify-content-end align-items-center">
                        {isUnitSelected ? (
                            <p className="facility-unit-card__info-toggler-text-remove">{sharedData.removeUnitFromReservationText}</p>
                        ) : (
                            <p className="facility-unit-card__info-toggler-text-add">{sharedData.addUnitToReservationText}</p>
                        )}
                        <div className={`facility-unit-card__info-toggler-switch ${isSelectDisabled ? 'toggler__content--disabled' : ''}`}>
                            <input
                                className="facility-unit-card__info-toggler-switch-input"
                                type="checkbox"
                                disabled={isSelectDisabled}
                                checked={isUnitSelected}
                                aria-label={`Toggle switch ${data.type}-${data.unitShortTitle}`}
                                onChange={() => selectHandler(priceData)}
                                onClick={() => {
                                    selectHandler(priceData);
                                    if (!IS_FRAME_SERVICE) {
                                        if (isUnitSelected) {
                                            dispatchTrackingEvent(RESERVATION_FORM_UNIT_CARD_REMOVE_UNIT);
                                            if (data.isMainUnit) {
                                                dispatchTrackingEvent(RESERVATION_FORM_UNIT_CARD_REMOVE_MAIN_UNIT);
                                            }
                                        } else {
                                            dispatchTrackingEvent(RESERVATION_FORM_UNIT_CARD_ADD_UNIT);
                                        }
                                    }
                                }}
                            />
                            <span className="facility-unit-card__info-toggler-switch-slider" />
                        </div>
                    </label>
                </div>
            </div>
        </div>
    );
}

export default FacilityUnitCard;
